import { FormGroup } from "@angular/forms";

export interface DialogData {
  title: string;
  description: string;
  icon?: string;
  actionButton?: string;
  cancelButton?: string;
  deleteAction?: boolean;
  productTitle?: string;
  description2?: string;
  rut?:string;
  errorCode?:string;
  preventDefaultSubmit?: boolean;

}

export interface DialogResult {
  action: ACTIONS;
  data?:any
}

export enum ACTIONS {
  OK = 'OK',
  CANCEL = 'CANCEL'
}
